import { formatAmount, formatDate } from "./commissionReportShared";

export const SEARCH_STORAGE_KEY = "zillion.downlineViewSearch";
export const DOWNLINE_PAGE_SIZES = [20, 50];
export const WALLET_TYPE_ORDER = ["main", "spot", "futures", "p2p", "swap", "earning", "staking"];

export { formatAmount, formatDate };

export const dash = (value) => {
  if (value == null || value === "") return "—";
  return value;
};

export const formatMoney = (amount, currency) => {
  if (amount == null || amount === "") return "—";
  const text = formatAmount(amount);
  return currency ? `${text} ${currency}` : text;
};

export const statusKind = (status) => {
  const s = String(status || "").toLowerCase();
  if (["active", "verified", "filled", "completed"].includes(s)) return "ok";
  if (["blocked", "rejected", "cancelled", "canceled", "inactive"].includes(s)) return "bad";
  if (s === "pending") return "pending";
  return "muted";
};

export const kycKind = (label) => {
  const s = String(label || "").toLowerCase();
  if (s.includes("verif")) return "ok";
  if (s.includes("reject")) return "bad";
  if (s.includes("pend")) return "pending";
  return "muted";
};

export const sideKind = (side) => (String(side || "").toUpperCase() === "BUY" ? "ok" : "sell");

export const readableType = (type) => {
  const map = {
    payout: "Payout",
    instant_bonus: "Instant bonus",
    signup_bonus: "Signup bonus",
    referral_bonus: "Referral bonus",
  };
  if (!type) return "—";
  return map[type] || String(type).replace(/_/g, " ");
};

export const groupWallets = (wallets) => {
  const groups = new Map();
  (wallets || []).forEach((wallet) => {
    const type = wallet?.wallet_type || "other";
    if (!groups.has(type)) groups.set(type, []);
    groups.get(type).push(wallet);
  });
  const ordered = WALLET_TYPE_ORDER.filter((type) => groups.has(type));
  groups.forEach((_, type) => {
    if (!ordered.includes(type)) ordered.push(type);
  });
  return ordered.map((type) => ({ type, rows: groups.get(type) }));
};

export const accessMessage = (res, fallback) => {
  if (res?.httpStatus === 401) return res?.message || "Unauthorized Request!";
  if (res?.httpStatus === 403) return res?.message || "You do not have permission for this action";
  return res?.message || fallback;
};
